import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { safeMutate } from '../../../../../utils/GeneralUtils';
import { useListSearch } from '../../../../../hooks/generic/Form/useListSearch';
import ChrCheckbox from '../../Basic/ChrCheckbox';
import SelectAllAndClear from '../../Basic/SelectAllAndClear';
import { getDataFromProps, getUId, propagateData, updateDataList } from '../../utils';

/*

props = {
  data: [{
    value: <>,
    label: <>,
    checked: < true || false >,
    disabled: < true || false >,
    className: <>,
    key: <>,
    name: <>
  }, ...],
  inline: < true || false >,
  onChange: <handler>,
  uId: <>
}

*/

const CheckBoxGroup = (props) => {
  const formData = getDataFromProps(props);
  const myUId = getUId(props);

  let [ListSearchComponent, choicesList] = useListSearch({
    list: formData,
    searchable: props.searchable,
    listItemValueMapper: choice => choice.label,
    inputRef: props.searchRef
  });

  const selectAllClear = {
    markAllCheckBox: (checked) => {
      const choicesToUpdate = choicesList.map(choice => choice.value);
      return safeMutate(formData, draftData => {
        draftData.forEach(choice => {
          if (choicesToUpdate.includes(choice.value))
            choice.checked = checked;
        });
      });
    },

    selectAllClickHandler: (event) => {
      const newFormData = selectAllClear.markAllCheckBox(true);
      propagateData("onChange", myUId, newFormData, props);
    },

    clearClickHandler: (event) => {
      const newFormData = selectAllClear.markAllCheckBox(false);
      propagateData("onChange", myUId, newFormData, props);
    }
  };


  const renderSelectAllClear = (props) => {
    if (props.renderSelectAllClear === true) {
      return (<SelectAllAndClear clearClickHandler={ selectAllClear.clearClickHandler } selectAllClickHandler={ selectAllClear.selectAllClickHandler } />);
    }
  };

  const onChangeHandler = (event, childUId, childData) => {
    const newFormData = updateDataList(formData, childUId, childData);
    propagateData(event, myUId, newFormData, props);
  };

  return (
    <React.Fragment>
      { ListSearchComponent }
      <FormGroup className={ props.formGroupClass }>
        {
          choicesList.map((choice) => {
            return (<ChrCheckbox key={ choice.uId } data={ choice } onChange={ onChangeHandler } uId={ choice.uId } />);
          })
        }
      </FormGroup>
      { renderSelectAllClear(props) }
    </React.Fragment>
  );
};

export default CheckBoxGroup;
